import React, { useEffect } from 'react';
import DetailPenyewa from '../DetailPenyewa';
import { TableWrapper } from 'components/Global';
import { ReactComponent as VehicleLogoIcon } from '../../../../../icons/custom-order-filled-icon.svg';
import DetailPembayaran from './DetailPembayaran';
import { useAppContext } from 'components/Context/AppContext';
import { useDispatch, useSelector } from 'react-redux';
import { createOrder } from 'features/orders/actions';
import MetodePembayaran from '../MetodePembayaran';
import { useLocation, useNavigate } from 'react-router-dom';
import { resetData } from 'features/orders/createOrder';
import { overtimeWithDriver } from '../DetailSewa/WithDriverForm';
import { ReactComponent as AirportLogoIcon } from 'icons/airport-transfer-filled-icon.svg';
import { overtimeWithoutDriver } from '../DetailSewa/WithoutDriverForm';
import { format, parseISO, subDays } from 'date-fns';
import { calculateEndBookingTime } from 'utils/calculate-end-booking-time-daily';

// STATE THAT CONFIRMATIONING IF THE PAGE IS CONFIRMATION ORDER
const isOrderConfirmation = true;

const KonfirmasiPesanan = ({
  nextPage,
  prevPage,
  orderData,
  setOrderData,
  // detail penyewa //
  depositBank,
  setDepositBank,
  depositAccountNumber,
  setDepositAccountNumber,
  ktpImageLink,
  setKtpImageLink,
  simImageLink,
  setSimImageLink,
  // detail sewa //
  vehicleInput,
  setVehicleInput,
  selectedCar,
  setSelectedCar,
  startRentDate,
  setStartRentDate,
  endRentDate,
  setEndRentDate,
  deliveryLocation,
  setDeliveryLocation,
  setReturnLocation,
  rentalLocation,
  setRentalLocation,
  refferalCode,
  setRefferalCode,
  returnLocation,
  allVehicle,
  selectedPaymentType,
  setSelectedPaymentType,
  // metode pembayaran //
  paymentImageLink,
  setPaymentImageLink,
  selectedOvertime,
  setSelectedOvertime,
  // with driver//
  durationRent,
  setDurationRent,
  dayDuration,
  setDayDuration,
  allZonesList,
  // airport transfer//
  isSwitch,
  setIsSwitch,
  selectedAdditionalItem,
  setSelectedAdditionalItem,
  luggageAirport,
  setLuggageAirport,
  passengersAirport,
  setPassengersAirport,
  startLocation,
  setStartLocation,
  endLocation,
  setEndLocation,
  locationData,
  setLocationData,
  isMeetAndGreetBoardRequire,
  setIsMeetAndGreetBoardRequire,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  const pathName = location.pathname.split('/').filter((item) => item !== '')[0];

  // CONTEXT
  const { showToast, setShowConfirmation, setShowSpinner } = useAppContext();
  const { data: summaryOrderData } = useSelector((state) => state.summaryOrder);

  // GLOBAL STATE
  const { status } = useSelector((state) => state.createOrder);
  const { data: rentalServicesData } = useSelector((state) => state.services);

  // SUBMIT AND CREATE ORDER
  const submitHandler = (e) => {
    e.preventDefault();

    let payload;

    if (pathName === 'airport-transfer') {
      const orderPayload = { ...orderData };
      delete orderPayload.order_detail.additionals;
      delete orderPayload.order_detail.without_driver;
      delete orderPayload.deposit;
      delete orderPayload.over_time_price;
      delete orderPayload.over_time;
      delete orderPayload.order_violations;
      delete orderPayload.remainder;
      delete orderPayload.down_payment;
      delete orderPayload.exceed_passenger_price;

      let mappingAdditionalItem = [];
      if (selectedAdditionalItem) {
        for (let addItionalChild of selectedAdditionalItem) {
          const additionalObj = {
            id: addItionalChild.additional.id,
            varieties: [
              {
                id: addItionalChild.additional.varieties[0].id,
                quantity: addItionalChild.total,
              },
            ],
          };

          mappingAdditionalItem.push(additionalObj);
        }
      }

      const subServiceAirportTransfer = rentalServicesData
        ?.find((item) => item.name === 'Sewa Mobil')
        ?.sub_services?.find((item) => item.name === 'Airport Transfer');

      payload = {
        ...orderPayload,
        currency: rentalLocation?.currency,
        order_detail: {
          ...orderPayload.order_detail,
          landing_time: orderData.order_detail.start_booking_time,
          end_booking_time: orderData.order_detail.end_booking_time,
          end_booking_date: orderData.order_detail.end_booking_date,
          loc_time_id: rentalLocation?.time_zone_identifier,
          location_id: rentalLocation?.id,
          dp_rule_id: summaryOrderData?.minimal_dp_rule?.id,
          baggage: isNaN(orderData.order_detail.baggage) ? 0 : orderData.order_detail.baggage,
          package_id: summaryOrderData?.order_airport_package.vehicle_category_package_id,
          sub_services_id: subServiceAirportTransfer?.id,
          ...(rentalLocation?.is_special_airport_transfer && {
            vehicle_id: 256,
          }),
          rental_delivery_type: isSwitch ? 'airport' : 'zone',
          rental_return_type: !isSwitch ? 'airport' : 'zone',
          rental_delivery_id: startLocation.id,
          rental_return_id: endLocation.id,
        },
        wa_number: orderPayload.wa_number,
        phone_number: orderPayload.phone_number,
        type: 'FULL',
        price_per_day: summaryOrderData?.price_per_day,
        outside_operational_charge: summaryOrderData?.outside_operational_charge,
        airport_transfer_package_id: orderData.airport_transfer_package_id,
        addons: mappingAdditionalItem.length === 0 ? undefined : mappingAdditionalItem,
        fee_meet_greet_board: orderData.customer_name_meet_and_greet ? summaryOrderData?.meet_greet_board?.fee : 0,
        use_meet_greet_board: isMeetAndGreetBoardRequire,
      };
    }

    if (pathName === 'with-driver' || pathName === 'without-driver') {
      let mappingAdditionalItem = [];

      if (selectedAdditionalItem) {
        for (let addItionalChild of selectedAdditionalItem) {
          const additionalObj = {
            id: addItionalChild.additional.id,
            varieties: [
              {
                id: addItionalChild.additional.varieties[0].id,
                quantity: addItionalChild.total,
              },
            ],
          };

          mappingAdditionalItem.push(additionalObj);
        }
      }

      const endBookingDateWithoutDriver =
        pathName === 'without-driver' &&
        overtimeWithoutDriver.find((ovt) => ovt.id === orderData.over_time)?.value > 0 &&
        orderData.order_detail.start_booking_time === '00:00' &&
        orderData.order_detail.end_booking_time.split(':')[1] === '30'
          ? subDays(parseISO(orderData.order_detail.end_booking_date), 1)
          : parseISO(orderData.order_detail.end_booking_date);

      let meetAndGreetBoardFee = 0;

      if (pathName === 'without-driver') {
        meetAndGreetBoardFee = orderData.customer_name_meet_and_greet && summaryOrderData?.meet_greet_board?.fee;
      } else if (pathName === 'with-driver') {
        orderData?.order_detail?.booking_zones.forEach((zone) => {
          if (zone.customer_name_meet_and_greet) {
            meetAndGreetBoardFee += summaryOrderData?.meet_greet_board?.fee;
          }
        });
      }

      let sub_services;

      const serviceData = rentalServicesData
        ?.find((item) => item.name === 'Sewa Mobil')
        ?.sub_services?.find((item) => item.name === 'Daily');

      if (pathName === 'without-driver') {
        sub_services = serviceData?.facilities?.find((item) => item.name === 'Without Driver');
      } else if (pathName === 'with-driver') {
        sub_services = serviceData?.facilities?.find((item) => item.name === 'With Driver');
      }

      payload = {
        ...orderData,
        wa_number: orderData.wa_number,
        phone_number: orderData.phone_number,
        deposit: isNaN(orderData.deposit) ? 0 : orderData.deposit,
        order_violations:
          orderData.order_violations.length === 0
            ? orderData.order_violations
            : orderData.order_violations.map((item) => {
                return { violation: item.violation, cost: item.cost };
              }),
        currency: rentalLocation?.currency,
        order_detail: {
          ...orderData.order_detail,
          booking_zones: orderData?.order_detail?.booking_zones?.map((item, idx) => ({
            ...item,
            driving_zone_price: summaryOrderData.order_zone_price[idx].driving_zone_price,
            drop_off_zone_price: summaryOrderData.order_zone_price[idx].drop_off_zone_price,
            pickup_zone_price: summaryOrderData.order_zone_price[idx].pick_up_zone_price,
            total_price: summaryOrderData.order_zone_price[idx].total_price,
            outside_operational_charge: summaryOrderData.order_zone_price[idx].outside_operational_charge,
            booking_start_time: dayDuration[idx].booking_start_time,
            booking_end_time:
              overtimeWithDriver.find((ovt) => ovt.id === dayDuration[idx].overtime_duration)?.value > 0
                ? `${
                    dayDuration[idx].booking_end_time.split(':')[0] -
                    overtimeWithDriver.find((ovt) => ovt.id === dayDuration[idx].overtime_duration)?.value
                  }:${dayDuration[idx].booking_end_time.split(':')[1]}`
                : dayDuration[idx].booking_end_time,
            overtime_duration:
              overtimeWithDriver.find((ovt) => ovt.id === dayDuration[idx].overtime_duration)?.value || 0,
            driver_stay_overnight_price: summaryOrderData.order_zone_price[idx].driver_stay_overnight_price,
            detail_drop_off_location: item.detail_drop_off_location.concat(
              ' - ',
              item.detail_drop_off_location_placeholder,
            ),
            detail_pickup_location: item.detail_pickup_location.concat(' - ', item.detail_pickup_location_placeholder),
          })),
          end_booking_date: format(endBookingDateWithoutDriver, 'yyyy-MM-dd'),
          end_booking_time: calculateEndBookingTime({ pathName, orderData, overtimeWithDriver, dayDuration }),
          start_booking_time:
            pathName === 'without-driver'
              ? orderData.order_detail.start_booking_time
              : dayDuration[0]?.booking_start_time,
          loc_time_id: rentalLocation?.time_zone_identifier,
          location_id: rentalLocation?.id,
          dp_rule_id: summaryOrderData?.minimal_dp_rule?.id,
          baggage: isNaN(orderData.order_detail.baggage) ? 0 : orderData.order_detail.baggage,
          package_id: undefined,
          sub_services_id: sub_services?.id,
          vehicle_category_id: selectedCar?.category?.id || undefined,
        },
        over_time_price: pathName === 'without-driver' ? summaryOrderData.over_time_price : undefined,
        over_time:
          pathName === 'without-driver'
            ? overtimeWithoutDriver.find((ovt) => ovt.id === orderData.over_time)?.value
            : undefined,
        order_overtime_total_price:
          pathName === 'with-driver' ? summaryOrderData.order_overtime_total_price : undefined,
        remainder: orderData.type === 'HALF' ? summaryOrderData?.remainder : 0,
        price_per_day: summaryOrderData?.price_per_day,
        exceed_passenger_price: summaryOrderData?.exced_max_passenger_charge,
        down_payment: orderData.type === 'HALF' ? summaryOrderData?.total_dp : 0,
        one_day_order_charge: summaryOrderData?.one_day_order_charge,
        outside_operational_charge: summaryOrderData?.outside_operational_charge,
        addons: mappingAdditionalItem.length === 0 ? undefined : mappingAdditionalItem,
        // notes: descriptionAdditionalItem ? undefined : descriptionAdditionalItem,
        fee_meet_greet_board: meetAndGreetBoardFee,
        ...(pathName === 'without-driver' && {
          use_meet_greet_board: isMeetAndGreetBoardRequire,
        }),
      };
    }

    if (summaryOrderData?.promotion) {
      payload.promotion_id = summaryOrderData.promotion.id;
    }

    setShowConfirmation({
      message: 'Apakah anda yakin ingin lanjut melakukan proses transaksi?',
      show: true,
      onClick: async () => {
        try {
          await dispatch(createOrder(payload)).unwrap();

          if (pathName === 'with-driver') {
            navigate(`/with-driver?status=ALL&locationId=${rentalLocation.id}`);
          } else if (pathName === 'without-driver') {
            navigate(`/without-driver?status=ALL&locationId=${rentalLocation.id}`);
          } else if (pathName === `airport-transfer`) {
            navigate(`/airport-transfer?status=ALL&locationId=${rentalLocation.id}`);
          }

          showToast({ type: 'success', message: 'Berhasil Proses Transaksi' });
          dispatch(resetData());
        } catch (error) {
          // eslint-disable-next-line no-console
          console.log(error);
          showToast({ type: 'error', message: 'Proses Transaksi Gagal' });
        }
      },
    });
  };

  // SHOW LOADING SPINNER
  useEffect(() => {
    if (status === 'loading') {
      setShowSpinner(true);
    } else {
      setShowSpinner(false);
    }
  }, [status]);

  return (
    <div className="order-confirmation">
      <TableWrapper
        icon={
          pathName === 'airport-transfer' ? (
            <AirportLogoIcon width="25px" height="25px" />
          ) : (
            <VehicleLogoIcon width="25px" height="25px" />
          )
        }
        title={pathName === 'airport-transfer' ? 'Custom Airport Transfer' : 'Custom Sewa Mobil'}
      >
        <DetailPenyewa
          nextPage={nextPage}
          orderData={orderData}
          setOrderData={setOrderData}
          depositBank={depositBank}
          setDepositBank={setDepositBank}
          depositAccountNumber={depositAccountNumber}
          setDepositAccountNumber={setDepositAccountNumber}
          ktpImageLink={ktpImageLink}
          setKtpImageLink={setKtpImageLink}
          simImageLink={simImageLink}
          setSimImageLink={setSimImageLink}
          prevPage={prevPage}
          vehicleInput={vehicleInput}
          setVehicleInput={setVehicleInput}
          selectedCar={selectedCar}
          setSelectedCar={setSelectedCar}
          startRentDate={startRentDate}
          setStartRentDate={setStartRentDate}
          endRentDate={endRentDate}
          setEndRentDate={setEndRentDate}
          deliveryLocation={deliveryLocation}
          setDeliveryLocation={setDeliveryLocation}
          returnLocation={returnLocation}
          setReturnLocation={setReturnLocation}
          rentalLocation={rentalLocation}
          setRentalLocation={setRentalLocation}
          refferalCode={refferalCode}
          setRefferalCode={setRefferalCode}
          isOrderConfirmation={isOrderConfirmation}
          allVehicle={allVehicle}
          selectedOvertime={selectedOvertime}
          setSelectedOvertime={setSelectedOvertime}
          selectedPaymentType={selectedPaymentType}
          setSelectedPaymentType={setSelectedPaymentType}
          // with driver//
          durationRent={durationRent}
          setDurationRent={setDurationRent}
          dayDuration={dayDuration}
          setDayDuration={setDayDuration}
          allZonesList={allZonesList}
          // airport transfer//
          isSwitch={isSwitch}
          setIsSwitch={setIsSwitch}
          selectedAdditionalItem={selectedAdditionalItem}
          setSelectedAdditionalItem={setSelectedAdditionalItem}
          luggageAirport={luggageAirport}
          setLuggageAirport={setLuggageAirport}
          passengersAirport={passengersAirport}
          setPassengersAirport={setPassengersAirport}
          startLocation={startLocation}
          setStartLocation={setStartLocation}
          endLocation={endLocation}
          setEndLocation={setEndLocation}
          locationData={locationData}
          setLocationData={setLocationData}
          isMeetAndGreetBoardRequire={isMeetAndGreetBoardRequire}
          setIsMeetAndGreetBoardRequire={setIsMeetAndGreetBoardRequire}
        />
      </TableWrapper>

      <div style={{ background: 'white', padding: '1px 16px 18px', margin: '22px 0', borderRadius: '4px' }}>
        <MetodePembayaran
          orderData={orderData}
          setOrderData={setOrderData}
          paymentImageLink={paymentImageLink}
          setPaymentImageLink={setPaymentImageLink}
          isOrderConfirmation={isOrderConfirmation}
        />
      </div>
      <DetailPembayaran
        prevPage={prevPage}
        nextPage={nextPage}
        orderData={orderData}
        setOrderData={setOrderData}
        returnLocation={returnLocation}
        deliveryLocation={deliveryLocation}
        selectedCar={selectedCar}
        submitHandler={submitHandler}
        durationRent={durationRent}
        selectedAdditionalItem={selectedAdditionalItem}
        isMeetAndGreetBoardRequire={isMeetAndGreetBoardRequire}
        setIsMeetAndGreetBoardRequire={setIsMeetAndGreetBoardRequire}
        startLocation={startLocation}
      />
    </div>
  );
};

export default KonfirmasiPesanan;
